import React, { Component } from 'react'


class Footer extends Component {
    
    constructor() {
        super()
        this.state = {
            quicklink: null,
            serviceslink: null,
            company_logo: "",
            email: null,
            phone: null,
            facebook_link: null,
            twitter_link: null,
            linkedin_link: null,
            about_company: null,
            phonenumber:null,
            emailink:null
        }    
    }

    async componentDidMount() {
        
        this.getData();
    }

    async getData() {
       await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/menus/v1/menus/quick-menu`).then((response) => {
            response.json().then((result) => {
                this.setState({ quicklink: result.items })
            })
        })

        await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/menus/v1/menus/services-menu`).then((response) => {
            response.json().then((result) => {
                this.setState({ serviceslink: result.items })
            })
        })
      
        await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/custom/v1/company-info`).then((response) => {
            response.json().then((result) => {                       
                this.setState({ 
                    company_logo: result.company_logo,                        
                    email: result.email,
                    phone: result.phone,
                    facebook_link: result.facebook_link,
                    twitter_link: result.twitter_link,
                    linkedin_link: result.linkedin_link,
                    about_company: result.about_company,
                    phonenumber: "tel:"+result.phone.replace(" ", ""),
                    emailink: "mailto:"+result.email
                })                           
            })
        })
    
    
    }

    render() {
        return (
            <>           
                {/* <!-- Footer Section Start --> */}
                <div className="section footer-section footer-section-03" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/footer-bg2.jpg)` }}>

                    <div className="container">
                        {/* <!-- Footer Widget Wrap Start --> */}
                        <div className="footer-widget-wrap">
                            <div className="row">
                                <div className="col-lg-3 col-sm-6">
                                    {/* <!-- Footer Widget Start --> */}
                                    <div className="footer-widget-about">
                                        <a className="footer-logo" href="/">
                                        {/* <img src={this.state.company_logo.toString()} alt="Logo" style={{filter: "invert(1)"}} /> */}
                                        <img src={`${process.env.PUBLIC_URL}/images/k-logo-w.png`} alt="Logo"  />
                                        </a>
                                        <p>{this.state.about_company}</p>
                                        <div className="footer-social">
                                            <ul className="social">
                                                <li><a href={this.state.facebook_link}><i className="fab fa-facebook-f"></i></a></li>
                                                <li><a href={this.state.twitter_link}><i className="fab fa-twitter"></i></a></li>
                                                <li><a href={this.state.linkedin_link}><i className="fab fa-linkedin-in"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <!-- Footer Widget End --> */}
                                </div>
                                <div className="col-lg-3 col-sm-6">
                                    {/* <!-- Footer Widget Start --> */}
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title">Useful Links</h4>

                                        <div className="widget-link">
                                            <ul className="link">
                                                {
                                                    this.state.quicklink?

                                                    this.state.quicklink.map((item, i) =>
                                                        <li key={i}><a href={item.slug==="home-page"?'/':'/'+item.slug}>{item.title}</a></li>                                               
                                                    )   
                                                    : null
                                                }
                                                
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <!-- Footer Widget End --> */}
                                </div>
                                <div className="col-lg-3 col-sm-6">
                                    {/* <!-- Footer Widget Start --> */}
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title">Our Services</h4>

                                        <div className="widget-link">
                                            <ul className="link">
                                            {
                                                    this.state.serviceslink?

                                                    this.state.serviceslink.map((item, i) =>
                                                        <li key={i}><a href={item.slug}>{item.title}</a></li>                                               
                                                    )   
                                                    : null
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <!-- Footer Widget End --> */}
                                </div>
                                <div className="col-lg-3 col-sm-6">
                                    {/* <!-- Footer Widget Start --> */}
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title">Contact Information</h4>

                                        <div className="widget-info">
                                            <ul>
                                                <li>
                                                    <div className="info-icon">
                                                        <i className="flaticon-phone-call"></i>
                                                    </div>
                                                    <div className="info-text">
                                                        
                                                        <span><a href={this.state.phonenumber}>+{this.state.phone}</a></span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-icon">
                                                        <i className="far fa-envelope-open"></i>
                                                    </div>
                                                    <div className="info-text">
                                                        <span><a href={this.state.emailink}>{this.state.email}</a></span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="info-icon">
                                                        <i className="flaticon-pin"></i>
                                                    </div>
                                                    <div className="info-text">
                                                        <span>427, Satya 2, Opp. Rannapark Bus Stand, Rannapark, Naranpura, Ahmedabad - 380013</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <!-- Footer Widget End --> */}
                                </div>
                            </div>
                        </div>
                        {/* <!-- Footer Widget Wrap End --> */}
                    </div>

                    {/* <!-- Footer Copyright Start --> */}
                    <div className="footer-copyright-area">
                        <div className="container">
                            <div className="footer-copyright-wrap">
                                <div className="row align-items-center">
                                    <div className="col-lg-12">
                                        {/* <!-- Footer Copyright Text Start --> */}
                                        <div className="copyright-text text-center">
                                            <p>@copyright Copyrights 2024 <a href='/'>KANOPUS WEB SOLUTIONS</a>. All rights reserved. </p>
                                        </div>
                                        {/* <!-- Footer Copyright Text End --> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Footer Copyright End --> */}
                </div>
                {/* <!-- Footer Section End -->*/ }

            </>
        )
    }
}

export default Footer